import {
  ApiListRequest,
  ApiListResponse,
  FacilityDTO,
  FacilityStatus,
} from "@gymflow/types";
import { infiniteQueryOptions, QueryKey } from "@tanstack/react-query";

import { api } from "../../api";
import { numberPagination } from "../../numberPagination";

const keys = {
  all: () => ["staffApiFacility"] as QueryKey,
  list: (filters: unknown) => [...keys.all(), "list", filters] as QueryKey,
};

export const staffApiFacility = {
  keys,
  queries: {},
  infiniteQueries: {
    list: (
      params?: {
        name?: string;
        status?: FacilityStatus;
        sort?: keyof FacilityDTO;
      } & Omit<ApiListRequest, "page">,
    ) =>
      infiniteQueryOptions({
        queryKey: keys.list(params),
        queryFn: async ({ pageParam }) =>
          (
            await api.get<ApiListResponse<FacilityDTO>>("/facility", {
              params: {
                sort: "name",
                status: "ACTIVE",
                ...params,
                page: pageParam,
              },
            })
          ).data,
        ...numberPagination,
      }),
  },
  mutations: {},
};
